// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var InsuranceStatus;
(function (InsuranceStatus) {
    InsuranceStatus["UNKNOWN"] = "UNKNOWN";
    InsuranceStatus["ACTIVE"] = "ACTIVE";
    InsuranceStatus["INACTIVE"] = "INACTIVE";
    InsuranceStatus["SELF_PAY"] = "SELF_PAY";
    InsuranceStatus["INCOMPLETE"] = "INCOMPLETE";
    InsuranceStatus["INVESTIGATE"] = "INVESTIGATE";
    InsuranceStatus["ERROR"] = "ERROR";
    InsuranceStatus["VERIFIED"] = "VERIFIED";
})(InsuranceStatus || (InsuranceStatus = {}));
export var InsuranceStatus_index;
(function (InsuranceStatus_index) {
    InsuranceStatus_index[InsuranceStatus_index["UNKNOWN"] = 0] = "UNKNOWN";
    InsuranceStatus_index[InsuranceStatus_index["ACTIVE"] = 1] = "ACTIVE";
    InsuranceStatus_index[InsuranceStatus_index["INACTIVE"] = 2] = "INACTIVE";
    InsuranceStatus_index[InsuranceStatus_index["SELF_PAY"] = 3] = "SELF_PAY";
    InsuranceStatus_index[InsuranceStatus_index["INCOMPLETE"] = 4] = "INCOMPLETE";
    InsuranceStatus_index[InsuranceStatus_index["INVESTIGATE"] = 5] = "INVESTIGATE";
    InsuranceStatus_index[InsuranceStatus_index["ERROR"] = 6] = "ERROR";
    InsuranceStatus_index[InsuranceStatus_index["VERIFIED"] = 7] = "VERIFIED";
})(InsuranceStatus_index || (InsuranceStatus_index = {}));
export const InsuranceVerificationAdapterService = {
    SampleEndpoint(fn, req) {
        return fn(`/insurance-verification/v1/sample`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    SignUpForWeaveTrial(fn, req) {
        return fn(`/insurance-verification/v1/trial-signup`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    SignUpForWeaveVerify(fn, req) {
        return fn(`/insurance-verification/v1/signup`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetPayersList(fn, req) {
        return fn(`/insurance-verification/v1/payers-list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetProvidersList(fn, req) {
        return fn(`/insurance-verification/v1/providers-list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetDentalCoverageInfo(fn, req) {
        return fn(`/insurance-verification/v1/dental-coverage-info`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetCachedDentalCoverageInfoByPersonId(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v1/person/${req["personId"]}/dental-coverage-info`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetDentalVerificationMetrics(fn, req) {
        return fn(`/insurance-verification/v1/metrics/dental-coverage-info?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetLocationDetailsForWeaveVerify(fn, req) {
        return fn(`/insurance-verification/v1/weave-verify-locations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetInsuranceVerificationDetails(fn, req) {
        return fn(`/insurance-verification/v1/insurance-verification-details?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetInsurancePlans(fn, req) {
        try {
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v1/${req["sourceId"]}/insurance-plans?${fm.renderURLSearchParams(req, ["sourceId"])}`, { method: "GET" });
    },
    GetOnederfulPayerID(fn, req) {
        return fn(`/insurance-verification/v1/onederful-payer-id`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CreateInsurance(fn, req) {
        try {
            fm.validateUrlParam(req["sourceId"], "sourceId");
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v1/${req["sourceId"]}/${req["personId"]}/create-insurance`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetInsuranceLog(fn, req) {
        try {
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v1/${req["sourceId"]}/insurance-log?${fm.renderURLSearchParams(req, ["sourceId"])}`, { method: "GET" });
    },
    GetInsuranceLogByPersonID(fn, req) {
        try {
            fm.validateUrlParam(req["sourceId"], "sourceId");
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v1/${req["sourceId"]}/${req["personId"]}/insurance-log?${fm.renderURLSearchParams(req, ["sourceId", "personId"])}`, { method: "GET" });
    },
    GetInsuranceLogByWritebackID(fn, req) {
        try {
            fm.validateUrlParam(req["sourceId"], "sourceId");
            fm.validateUrlParam(req["writebackId"], "writebackId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v1/${req["sourceId"]}/insurance-log/${req["writebackId"]}?${fm.renderURLSearchParams(req, ["sourceId", "writebackId"])}`, { method: "GET" });
    },
    GetInsuranceEligibilityPDFReport(fn, req) {
        try {
            fm.validateUrlParam(req["submissionId"], "submissionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v1/insurance-eligibility-pdf-report/${req["submissionId"]}?${fm.renderURLSearchParams(req, ["submissionId"])}`, { method: "GET" });
    },
    SaveInsuranceEligibilityReport(fn, req) {
        try {
            fm.validateUrlParam(req["sourceId"], "sourceId");
            fm.validateUrlParam(req["personPmsId"], "personPmsId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v1/${req["sourceId"]}/${req["personPmsId"]}/insurance-eligibility-report`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetLocationSettings(fn, req) {
        return fn(`/insurance-verification/v1/location-settings?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SaveLocationSettings(fn, req) {
        return fn(`/insurance-verification/v1/location-settings`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetTrialDaysLeft(fn, req) {
        return fn(`/insurance-verification/v1/trial-days-left?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    OptOutWeaveTrial(fn, req) {
        return fn(`/insurance-verification/v1/trial-opt-out`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    SubmitFeedback(fn, req) {
        return fn(`/insurance-verification/v1/feedback`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetVerificationMetrics(fn, req) {
        return fn(`/insurance-verification/v1/verification-metrics?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    OverrideInsuranceStatus(fn, req) {
        return fn(`/insurance-verification/v1/insurance-status-override`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetInsuranceStatusOverride(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v1/${req["personId"]}/insurance-status-override?${fm.renderURLSearchParams(req, ["personId"])}`, { method: "GET" });
    },
    DeleteInsuranceStatusOverride(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v1/${req["personId"]}/insurance-status-override?${fm.renderURLSearchParams(req, ["personId"])}`, { method: "DELETE" });
    },
};
